export function ImgDragHandle({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 6h.01M16 6h.01" />
      <path d="M8 12h.01M16 12h.01" />
      <path d="M8 18h.01M16 18h.01" />
    </svg>
  );
}
